import React from "react";
import useApiEp from "../../hooks/useApiEp";

const RdCampaignCheck = ({ id }) => {
  const { data } = useApiEp(`/campaign/get-campaign-detail/${id}`);
  return <div></div>;
};

export default RdCampaignCheck;
